<template>
    <div class="user-tile" :class="position">
        <div v-if="user" class="user-content">
            <img :src="`/assets/${position}.svg`" width="50px" height="50px" alt="">
            <img :src="user.picture" width="80px" height="80px" class="user-img" alt="">

            <div class="mt-3 user-name">{{ user.name }}</div>

            <coin-chip
                class="mt-3 coins-amount"
            >
                <template #amount>
                    <span class="ml-1" style="font-weight: 600;">{{ Math.floor(user.coins_earned) }}</span>
                </template>
            </coin-chip>

            <country-flag :country="user.country.toLowerCase()" />
        </div>
    </div>
</template>

<script>
import CoinChip from "@/components/Common/CoinChip.vue";
import CountryFlag from "vue-country-flag-next";

export default {
    name: "User-Tile",
    props: {
        user: {
            type: Object,
            required: true
        },
        position: {
            type: String,
            required: true
        }
    },
    components: {
        CoinChip,
        CountryFlag
    },
}
</script>

<style lang="scss" scoped>
.user-tile {
    width: 215px;
    border-radius: 16px;
    border-top: 1px solid #FFFFFF99;
    &.silver {
        background:radial-gradient(68.6% 46.56% at 50% 3.47%, rgba(194, 199, 205, 0.6) 0%, rgba(49, 53, 65, 0) 100%),
            linear-gradient(180deg, #323643 0%, rgba(24, 26, 32, 0) 100%);

        .user-img {
            border: 1px solid #C2C7CD;
        }
    }
    &.gold {
        margin-top: -30px;
        background: radial-gradient(68.6% 46.56% at 50% 3.47%, rgba(229, 181, 43, 0.6) 0%, rgba(49, 53, 65, 0) 100%),
            linear-gradient(180deg, #323643 0%, rgba(24, 26, 32, 0) 100%);

        .user-img {
            border: 1px solid #E5B52B;
        }
    }
    &.bronze {
        background: radial-gradient(68.6% 46.56% at 50% 3.47%, rgba(109, 54, 18, 0.6) 0%, rgba(49, 53, 65, 0) 100%),
            linear-gradient(180deg, #323643 0%, rgba(24, 26, 32, 0) 100%);

        .user-img {
            border: 1px solid #6D3612;
        }
    }
    .user-content {
        display: flex;
        width: max-content;
        align-items: center;
        flex-direction: column;
        margin: -30px auto auto;
        .user-img {
            border-radius: 100px;
        }
        .user-name {
            font-size: 15px;
        }
    }

    @media only screen and (max-width: vars.get-map-value(vars.$breakpoints, mobile)) {
        position: relative;

        &.silver, &.bronze {
            width: 150px;
            margin-top: 200px;
        }
        &.gold {
            width: 311px;
            height: 177px;
            margin-top: -10px;
            position: absolute;
            .user-content {
                display: grid;
                margin: 25px auto auto;
                grid-template-areas:
                    "a b"
                    "a c"
                    "d d";

                img:first-child {
                    left: 50%;
                    top: -28px;
                    position: absolute;
                    transform: translateX(-50%);
                }
                .user-img {
                    grid-area: a;
                    margin-right: 12px;
                }
                .user-name {
                    grid-area: b;
                    margin: 0 !important;
                }
                .coins-amount {
                    grid-area: c;
                    width: max-content;
                    margin: 0 !important;
                }
                .flag {
                    grid-area: d;
                    margin-left: 37%
                }
            }
        }
    }
}
</style>
